const AGE_GATE_COOKIE_NAME = "kfa_age_verified";
const AGE_GATE_COOKIE_VALUE = "true";
const AGE_GATE_COOKIE_DAYS = 180;

export function hasConfirmedAgeGate(): boolean {
  if (typeof document === "undefined") {
    return false;
  }

  const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
  const match = cookies.find((cookie) =>
    cookie.startsWith(`${AGE_GATE_COOKIE_NAME}=`)
  );

  if (!match) {
    return false;
  }

  return match.split("=")[1] === AGE_GATE_COOKIE_VALUE;
}

export function confirmAgeGate(): void {
  if (typeof document === "undefined") {
    return;
  }

  const maxAge = AGE_GATE_COOKIE_DAYS * 24 * 60 * 60;
  document.cookie = `${AGE_GATE_COOKIE_NAME}=${AGE_GATE_COOKIE_VALUE}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
}
